import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  InputAdornment,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
} from "../../../Utility/Utilitys";
import { getGlobals } from "../../../Configs";
import { useSelector } from "react-redux";
import { FileDownloadOutlined } from "@mui/icons-material";

const ItemSelectionModal = ({
  onClickSave,
  headObj,
  xMediaQuery,
  vMediaQuery,
}) => {
  const bMediaQuery = useMediaQuery("(max-width:1200px)");
  const [filterData, setFilterData] = useState({
    location: headObj?.location,
    fromDate: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1,
      1,
      0,
      0
    ),
    toDate: new Date(), // Default future date
    void: "N",
    cancel: "N",
    return: "N",
    StockAdjustment: "N",
    PurchaseReturn: "N",
    SalesReturn: "N",
    DeleteInsert: "N",
  });
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState(null);
  const [detailExcelData, setDetailExcelData] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [validateData, setValidateData] = useState([]);
  const LocWithRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const [selectedRows, setSelectedRows] = useState([]); // State for selected rows
  const [dataRows, setDataRows] = useState([]);

  let detailInitObj = {
    ItmCd: "",
    ItmName: "",
  };

  const baseURL = getGlobals().API_BASE_URL;

  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    setFilterData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? "Y" : "N") : value,
    }));
  };

  const updateCountedStatus = (tableData, validateData) => {
    const ValidateData = new Set(validateData.map((item) => item.ItmCd));

    return tableData.map((item) => ({
      ...item,
      counted: ValidateData.has(item.ItmCd) ? "Y" : "N",
    }));
  };

  const columns = [
    { field: "ItmCd", headerName: "Item Code", width: xMediaQuery ? 90 : 120 },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: xMediaQuery ? 250 : 0,
      flex: xMediaQuery ? 0 : 2,
    },
    // {
    //   field: "CancelledQty",
    //   headerName: "Cancelled",
    //   width: 80,
    // },
    // { field: "VoidQty", headerName: "Void", width: 80 },
    // { field: "PRQty", headerName: "PR", width: 80 },
    // { field: "AdjQty", headerName: "Adj", width: 80 },
    // { field: "SrQty", headerName: "SR", width: 80 },
    // { field: "counted", headerName: "Counted", width: 80 },
  ];

  const handleSelectionChange = (selectedIds) => {
    // Find the full object for each selected ID
    const selectedObjects = dataRows?.filter((row) =>
      selectedIds.includes(row.ItmCd)
    );

    // Update state with full row data
    setSelectedRows(selectedObjects);
  };

  const fSave = () => {
    let iArray = selectedRows?.map((obj) => ({
      B_ItmCd: obj.ItmCd,
      // P_B_CancelledQty: obj.CancelledQty,
      // P_B_VoidQty: obj.VoidQty,
      // P_B_ReturnQt: obj.ReturnQty,
      // P_B_AdjustQty: obj.AdjQty,
      // P_B_PurchaseReturnQty: obj.PRQty,
      // P_B_SrQty: obj.SrQty,
    }));
    onClickSave(iArray, filterData?.DeleteInsert);
  };

  // const getCyclePhysicalItems = async () => {
  //   let loader = document?.getElementById("loader");
  //   loader.style.display = "flex";
  //   try {
  //     const response = await axios.post(
  //       `${baseURL}cyclicCount/getCyclePhysicalItems`,
  //       fcheck_null_undefine_replace_empty({
  //         DateFrom: moment(filterData?.fromDate).format("MM/DD/YYYY"),
  //         DateTo: moment(filterData?.toDate).format("MM/DD/YYYY"),
  //         Loc: filterData?.location,
  //       })
  //     );
  //     if (response?.status === 200) {
  //       loader.style.display = "none";
  //       setValidateData(response?.data?.ResultSet);
  //       return response?.data?.ResultSet;
  //     }
  //   } catch (error) {
  //     loader.style.display = "none";
  //   }
  // };

  // const getPOSItemsToCheckPhysical = async () => {
  //   let loader = document?.getElementById("loader");
  //   loader.style.display = "flex";
  //   try {
  //     const response = await axios.post(
  //       `${baseURL}cyclicCount/getPOSItemsToCheckPhysical`,
  //       fcheck_null_undefine_replace_empty({
  //         DateFrom: moment(filterData?.fromDate).format("MM/DD/YYYY"),
  //         DateTo: moment(filterData?.toDate).format("MM/DD/YYYY"),
  //         Loc: filterData?.location,
  //         Cancel: filterData?.cancel,
  //         Void: filterData?.void,
  //         Return: filterData?.return,
  //         PR: filterData?.PurchaseReturn,
  //         Adj: filterData?.StockAdjustment,
  //         Sr: filterData?.SalesReturn,
  //       })
  //     );
  //     if (response?.status === 200) {
  //       setTableData(response?.data?.ResultSet);
  //       loader.style.display = "none";
  //       return response?.data?.ResultSet;
  //     }
  //   } catch (error) {
  //     loader.style.display = "none";
  //   }
  // };

  // const onClickLoad = async () => {
  //   setFilePath("");
  //   if (fileInputRef.current) {
  //     fileInputRef.current.value = "";
  //   }
  //   const tableRes = await getPOSItemsToCheckPhysical();
  //   const validateRes = await getCyclePhysicalItems();

  //   const updatedArray = updateCountedStatus(tableRes, validateRes);
  //   setDataRows(updatedArray);
  // };

  const handleRowClick = (item) => {};

  const fImport = () => {
    if (filePath == "" || filePath == null || filePath == undefined) {
      fAlertToast("FAILED", "Choose one file");
      return;
    } else {
      const updatedDetailExcelData = detailExcelData.map((item) => ({
        ...item,
        // CancelledQty: 0,
        // VoidQty: 0,
        // ReturnQty: 0,
        // PRQty: 0,
        // AdjQty: 0,
        // SrQty: 0,
      }));

      setDataRows(updatedDetailExcelData);
      fAlertToast("SUCCESS", "File uploaded");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setFilePath(file.name); // Update the file path in state

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(sheet); // Convert sheet to JSON

        setDetailExcelData(excelData);
      };
      reader.readAsArrayBuffer(file);
    }
  };

  return (
    <Box className="stock-detail">
      <Grid
        container
        // justifyContent={"end"}
        alignItems={"center"}
        paddingTop={2}
      >
        <Grid xs={12} sm={12} md={12} lg={5.5}>
          <Typography>
            Note: Load from sheet 1(Column field : ItmCd,ItmName)
          </Typography>
        </Grid>
        <Grid xs={10} sm={6} md={6.5} lg={3.1}>
          <TextField
            size="small"
            sx={{
              mr: 2,
              "& .MuiOutlinedInput-root": {
                paddingRight: "0px !important",
              },
              "& .MuiInputBase-input": {
                padding: vMediaQuery ? "5.5px 10px !important" : "",
              },
            }}
            variant="outlined"
            placeholder="Excel upload"
            value={filePath}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <Button
                    variant="contained"
                    size="small"
                    component="label"
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 500,
                      fontSize: vMediaQuery
                        ? "11px !important"
                        : "13px !important",
                      padding: "0px 8px !important",
                    }}
                    onClick={() => {
                      setDataRows([]);
                      setTableData([]);
                    }}
                  >
                    Choose File
                    <input
                      ref={fileInputRef}
                      type="file"
                      accept=".xlsx, .xls"
                      hidden
                      onChange={handleFileChange}
                    />
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs={2} sm={1.5} md={1.5} lg={0.6} textAlign={"left"}>
          <Button
            variant="contained"
            sx={{
              height: vMediaQuery ? "26px" : "30px",
              mt: vMediaQuery ? 1 : 0,
              mr: 1,
              textTransform: "capitalize",
              ml: 2,
            }}
            onClick={fImport}
          >
            Download
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          md={3}
          lg={1.8}
          paddingLeft={vMediaQuery ? 0 : 3}
          mt={vMediaQuery ? 1 : 0}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={filterData.DeleteInsert === "Y"}
                onChange={handleChange}
                name="DeleteInsert"
              />
            }
            label={"Delete & Insert"}
          />
        </Grid>
        <Grid item xs={6} sm={1} md={1} lg={1} textAlign={"right"}>
          <Button
            variant="contained"
            sx={{
              height: vMediaQuery ? "26px" : "30px",
              mt: vMediaQuery ? 1 : 0,
              mr: 1,
              textTransform: "capitalize",
            }}
            onClick={() => {
              if (dataRows?.length > 0) {
                fSave();
              } else {
                fAlertToast("FAILED", "Grid should not be empty");
              }
            }}
          >
            Save
          </Button>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Box
        sx={{
          height: vMediaQuery ? "60vh" : "55vh",
          width: "100%",
          mt: 1,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          components={{ Toolbar: GridToolbar }}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            ".MuiCheckbox-root": { padding: "4px !important" },
            ".MuiDataGrid-columnHeaderCheckbox": {
              width: vMediaQuery ? "30px !important" : "50px",
              minWidth: vMediaQuery ? "30px !important" : "50px",
            },
            ".MuiDataGrid-cellCheckbox": {
              minWidth: vMediaQuery ? "30px !important" : "50px",
              maxWidth: vMediaQuery ? "30px !important" : "50px",
            },
          }}
          rows={dataRows}
          getRowId={(v) => v.ItmCd}
          columns={columns}
          onRowClick={handleRowClick}
          hideFooter={dataRows?.length < 100}
          checkboxSelection // Enables checkboxes
          disableSelectionOnClick // Prevents row selection when clicking inside a row
          onSelectionModelChange={handleSelectionChange}
        />
      </Box>
    </Box>
  );
};

export default ItemSelectionModal;
